import loadTexture from "../engine/gl/utils/loadTexture";
import gradientTexURL from "url:/src/img/gradient.png";
import starsTexURL from "url:/src/img/stars-texture.png";
import windowsTexURL from "url:/src/img/windows.jpg";
import shader1 from "./shaders/pass1.frag";
import shader2 from "./shaders/pass2.frag";
import Engine from "../engine";


export default function(){
    const engine = new Engine("gl-canvas", [
        {
            fragment: shader1,
            uniforms: { 
                gradient: {
                    name: "u_gradient",
                    type: "t",
                },
                stars: {
                    name: "u_stars",
                    type: "t"
                },
                boss_position: {
                    name: "u_boss_position",
                    type: "f",
                    size: 2,
                },
                music_intensity: {
                    name: "u_music_intensity",
                    type: "f",
                    size: 1,
                },
            }
        },
        {
            fragment: shader2,
            uniforms: {
                music_volume: {
                    name: "u_music_volume",
                    type: "f",
                    size: 1,
                },
                damage: {
                    name: "u_damage",
                    type: "f",
                    size: 1,
                },
                deathtransition: {
                    name: "u_deathtransition",
                    type: "f",
                    size: 1,
                },
                windowsTex: {
                    name: "u_windowsTex",
                    type: "t"
                },
            }
        }
    ]);
    engine.renderer.passes[0].material.uniforms.gradient.value = loadTexture(engine.renderer.gl, gradientTexURL);
    engine.renderer.passes[0].material.uniforms.stars.value = loadTexture(engine.renderer.gl, starsTexURL);
    engine.renderer.passes[1].material.uniforms.windowsTex.value = loadTexture(engine.renderer.gl, windowsTexURL);
    return engine;
}